import client from "../client";

export interface GetMessageRequest {
  prefix?: string;
  username?: string;
  start?: number | undefined;
  stop?: number | undefined;
  chats: GetMessageResponse[];
}

export interface GetMessageResponse {
  Username?: string;
  IsAdmin?: boolean;
  Text?: string;
  TypeID?: number;
  CreateAt?: number;
  IsSeeAdmin?: boolean;
  IsSeeUser?: boolean;
}

export default function API(
  request: GetMessageRequest
): Promise<GetMessageResponse[]> {
  const { chats } = request;

  request.start = chats.length;
  request.stop = -1;

  return client
    .get(`chat/get_message`, {
      params: {
        prefix: request.prefix,
        username: request.username,
        start: request.start,
        stop: request.stop,
      },
    })
    .then((response) => response.data)
    .then((json: GetMessageResponse[]) => {
      return json;
    });
}
